import { Island, Parish } from 'components/common/types'
import React, { useEffect } from 'react'
import Select from 'react-select'
import { Locations } from 'reducers/orderReducer'

interface Props {
  locations: Locations | null
  parishes: Parish[]
  island: Island
  parishTown: string
  handleLocationSelect: (island: Island) => void
  handleSelectParish: (option: ParishOption) => void
  children: React.ReactChild
}

export type ParishOption = {
  label: string
  parish: Parish['Parish']
  town: string
}

const CustomAddressSelect = ({
  locations,
  parishes,
  island,
  parishTown,
  handleLocationSelect,
  handleSelectParish,
  children
}: Props) => {
  useEffect(() => {
    if (locations?.islands?.length === 1) {
      const [island] = locations?.islands

      handleLocationSelect(island)
    }
  }, [locations])

  const parishOptions = parishes
    .map((parish) =>
      parish.Villages.map((village) => ({
        label: `${village} - ${parish.Parish}`,
        parish: parish.Parish,
        town: village
      }))
    )
    .flat()

  return (
    <>
      <Select
        className="mb-4"
        options={locations?.islands}
        defaultValue={
          island.label
            ? island
            : locations?.islands?.length === 1
            ? locations.islands?.[0]
            : null
        }
        getOptionLabel={(option) => `${option.label}`}
        isSearchable={false}
        placeholder="Select"
        onChange={(island: Island) => handleLocationSelect(island)}
      />

      {Object.keys(island).length !== 0 && (
        <Select
          options={parishOptions}
          getOptionLabel={(option) => `${option.label}`}
          getOptionValue={(option) => `${option.label}`}
          defaultValue={
            parishTown
              ? {
                  label: parishTown,
                  parish: '',
                  town: ''
                }
              : null
          }
          placeholder="Select Or Search"
          onChange={(option: ParishOption) => handleSelectParish(option)}
        />
      )}

      {children}
    </>
  )
}

export default CustomAddressSelect
